
export default function FeaturedPost() {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-semibold">Featured Article</span>
        </div>

        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="md:flex">
            <div className="md:w-1/2">
              <img
                src="https://public.readdy.ai/ai/img_res/6fcff150b95d4afbfeb857f1c5679199.jpg"
                alt="Featured blog post"
                className="w-full h-64 md:h-full object-cover object-top"
              />
            </div>
            <div className="md:w-1/2 p-8">
              <div className="flex items-center mb-4">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">Training Tips</span>
                <span className="text-gray-500 ml-4 text-sm">March 15, 2024</span>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                10 Essential Ball Control Drills Every Young Player Should Master
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Ball control is the foundation of great soccer. These proven drills will help young players develop the touch, confidence, and technical skills needed to excel on the field. From basic juggling to advanced first-touch exercises, master these fundamentals to elevate your game.
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20soccer%20coach%20headshot%20portrait%2C%20friendly%20and%20experienced%20male%20coach%20in%20his%2030s%20wearing%20soccer%20academy%20polo%20shirt%2C%20clean%20background%20for%20professional%20profile%20photo&width=50&height=50&seq=coach-author&orientation=squarish"
                    alt="Coach Martinez"
                    className="w-12 h-12 rounded-full object-cover object-top mr-3"
                  />
                  <div>
                    <p className="font-semibold text-gray-900">Coach Martinez</p>
                    <p className="text-sm text-gray-500">Head Technical Director</p>
                  </div>
                </div>
                <button className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                  Read More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
